import React from "react"
import gallerySmallStyles from "./gallerySmall.module.scss"
import { Link } from "gatsby"
import Img from "gatsby-image"

import PageTransition from "gatsby-v2-plugin-page-transitions"

const GallerySmall = (props, location) => {
  return (
    <section className={gallerySmallStyles.gallery}>
      <h1>{props.title}</h1>

      <ul className="breadcrumbs">
        <li className="breadcrumbs__item">
          <Link to="/#portfolio">Portfolio</Link>
        </li>
        <li className="breadcrumbs__item current">{props.title}</li>
      </ul>
      <PageTransition>
        <div className={gallerySmallStyles.gallery_container}>
          {props.contentfullData.allContentfulAlbum.edges.map(edge => {
            return (
              <div className={gallerySmallStyles.gallery__item}>
                <Link to={`/album/${edge.node.nazwa}`}>
                  <Img fluid={edge.node.zdjecie_albumu.fluid}></Img>
                  <h2>{edge.node.nazwa}</h2>
                </Link>
              </div>
            )
          })}
        </div>
      </PageTransition>
    </section>
  )
}
export default GallerySmall
